import { createFileRoute } from '@tanstack/react-router'
import { PayrollListFeature } from '@/features/payroll/ui/PayrollListFeature'
import { PayrollAccessDenied } from '@/features/payroll/ui/PayrollAccessDenied'
import { PermissionGuard } from '@/shared/components/PermissionGuard'
import { PERMISSIONS } from '@/shared/config/permissions'

function PayrollPage() {
  return (
    <PermissionGuard
      permission={PERMISSIONS.PayrollView}
      fallback={<PayrollAccessDenied />}
    >
      <PayrollListFeature />
    </PermissionGuard>
  )
}

export const Route = createFileRoute('/payroll/')({
  component: PayrollPage,
  staticData: { authorize: true },
})
